import { toast } from "sonner";

// Stripe and Intuit refuse to load inside frames (e.g. an embedded preview), so framed pages open them in a new tab.
const framed = () => {
  try { return window.self !== window.top; } catch { return true; }
};

export const openExternal = async (getUrl) => {
  const tab = framed() ? window.open("", "_blank") : null;
  try {
    const url = await getUrl();
    if (tab) { tab.opener = null; tab.location.href = url; } else window.location.href = url;
  } catch (e) {
    if (tab) tab.close();
    throw e;
  }
};

const MSG = "cr-oauth";
const FLAG = "cr-oauth-popup";
let active = null;

// Opens a provider's sign-in in a small window over the app; falls back to a full redirect if pop-ups are blocked.
export const openOAuthPopup = async (getUrl, { onDone, onClosed } = {}) => {
  const w = 520, h = 720;
  const left = window.screenX + Math.max(0, (window.outerWidth - w) / 2);
  const top = window.screenY + Math.max(0, (window.outerHeight - h) / 2);
  const pop = window.open("", "cr-oauth-window", `popup=yes,width=${w},height=${h},left=${left},top=${top}`);
  if (!pop) return openExternal(getUrl);
  pop.document.title = "Connecting…";
  try { pop.sessionStorage.setItem(FLAG, "1"); } catch { /* the opener channel still works */ }
  let url;
  try {
    url = await getUrl();
  } catch (e) {
    pop.close();
    throw e;
  }
  pop.location.href = url;
  let finished = false;
  const channel = "BroadcastChannel" in window ? new BroadcastChannel(MSG) : null;
  const handle = (data) => {
    if (finished || data?.type !== MSG) return;
    finished = true;
    cleanup();
    onDone?.(data);
  };
  const onMsg = (ev) => { if (ev.origin === window.location.origin) handle(ev.data); };
  if (channel) channel.onmessage = (ev) => handle(ev.data);
  const timer = setInterval(() => {
    let closed = false;
    try { closed = pop.closed; } catch { closed = false; }
    if (closed) { clearInterval(timer); if (!finished) onClosed?.(); setTimeout(cleanup, 3000); }
  }, 500);
  const cleanup = () => { clearInterval(timer); window.removeEventListener("message", onMsg); channel?.close(); if (active === cleanup) active = null; };
  active?.();
  active = cleanup;
  window.addEventListener("message", onMsg);
  setTimeout(cleanup, 15 * 60 * 1000);
  pop.focus();
};

// Inside the pop-up: hand the result back to the app window and close. Returns false when not in a pop-up.
export const finishOAuthPopup = (result) => {
  let opener = null;
  try { opener = window.opener && window.opener.location.origin === window.location.origin ? window.opener : null; } catch { opener = null; }
  let flagged = false;
  try { flagged = sessionStorage.getItem(FLAG) === "1"; sessionStorage.removeItem(FLAG); } catch { flagged = false; }
  if (!opener && !flagged) return false;
  const data = { type: MSG, ...result };
  if (opener) opener.postMessage(data, window.location.origin);
  if ("BroadcastChannel" in window) { const ch = new BroadcastChannel(MSG); ch.postMessage(data); ch.close(); }
  window.close();
  setTimeout(() => toast[result.ok ? "success" : "error"](`${result.message}. You can close this window.`, { duration: 60000 }), 400);
  return true;
};
